"use client";

import { gql } from "graphql-request";
import { useGraphqlQuery } from "@/lib/graphql/useGraphql";

const stripeConfigDocument = gql`
  query StripeConfig {
    stripe_config {
      stripe_mode
    }
  }
`;

type StripeConfigQuery = {
  stripe_config: {
    stripe_mode: string;
  };
};

export const useStripeConfig = () => {
  const { data, isLoading, error } = useGraphqlQuery<StripeConfigQuery>({
    queryKey: ["stripe-config"],
    document: stripeConfigDocument,
    retry: false,
  });

  return {
    isLoading,
    error,
    stripeMode: data?.stripe_config.stripe_mode ?? null,
    isTestMode: data?.stripe_config.stripe_mode === "test",
    isLiveMode: data?.stripe_config.stripe_mode === "live",
  };
};
